import React from "react";
import configs from "utils/globals";
import { useTranslation } from "react-i18next";
import { ReactComponent as Failed } from "assets/icons/failed.svg";
import { ReactComponent as Success } from "assets/icons/success.svg";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-dashed.svg";
import { ReactComponent as LogoFirouzehWigth } from "assets/images/logo/logo-firouzeh-wigth.svg";
import { ReactComponent as LogoFirouzehWithoutTypo } from "assets/images/logo/logo-firouzeh-without-typo.svg";

import { digitsEnToFa } from "@persian-tools/persian-tools";

import {
  renderReceiptTitle,
  renderReceiptText,
  paymentMethodType,
} from "containers/operationsReceipt/services/data.transformers";

const BankActivation = ({
  amount = 0,
  bank_reference,
  destination_title,
  destination_icon,
  transaction_type,
  status,
  updated_at,
  user = {},
  onGenerateSourceAccount,
}) => {
  const { t } = useTranslation();

  const renderSourceAndDescription = () => {
    return (
      <div className="mt-5 border-t border-b border-gary--8 py-5">
        <div className="body-14px-medium tracking-normal text-gray-4">
          {user.name}
        </div>
        <div className="flex items-center justify-center gap-3">
          <span className="body-14px-medium tracking-normal text-gray-4 ltr ">
            {onGenerateSourceAccount()[0]}
          </span>
          <div className="h-10 w-10 rounded-xl bg-primary--7 flex items-center justify-center">
            <img
              alt="logo"
              src={
                "https://cdn.firouzeh.com/public/logo-firouzeh-without-typo.svg"
              }
              className="w-6"
            />
          </div>
        </div>
        <div className="table m-auto">
          <ArrowDown className="[&>path]:stroke-primary-0 w-6" />
        </div>

        <div className="body-14px-medium tracking-normal text-gray-4">
          {destination_title}
        </div>
        <div className="flex items-center justify-center gap-3">
          <span className="body-14px-medium tracking-normal text-gray-4 ltr">
            {onGenerateSourceAccount()[1]}
          </span>
          <div className="h-10 w-10 rounded-xl bg-primary--7 flex items-center justify-center">
            {destination_icon && (
              <img src={destination_icon} className="w-6" alt="" title="" />
            )}
          </div>
        </div>
      </div>
    );
  };

  const before =
    "relative pr-3 before:content-[''] before:absolute before:bg-primary--1 before:w-[6px] before:h-[6px] before:right-0 before:top-[10px] before:rotate-45";

  return (
    <div className="w-full relative bg-cover bg-white font-dana rounded-xl overflow-hidden z-20">
      <div className="text-center relative py-5 px-4 z-10  ">
        <div className="w-12 h-12 table m-auto mb-2 mt-4">
          <div className="w-12 h-12 relative flex justify-center items-center">
            {status === "DONE" && <Success className="w-12 h-12 " />}
            {["FAILED", "TROUBLESHOOTING"].includes(status) && (
              <Failed className="w-12 h-12 " />
            )}
          </div>
        </div>
        <div
          className={`text-center ${renderReceiptText(
            status
          )} body-16px-medium mb-3`}
        >
          {t(renderReceiptTitle(status))}
        </div>
        <div className="body-14px-medium tracking-normal text-gray-0 mb-3">
          {t("bank.pay-from-firouzeh")}
        </div>
        {renderSourceAndDescription()}
        <div className="pt-5 mt-5 flex flex-col gap-3">
          <div className="flex justify-between items-center relative">
            <span
              className={`body-14px-medium tracking-normal text-gray-0  ${before}`}
            >
              {t("bank.price")}
            </span>
            <div className="body-14px-medium tracking-normal text-gray-4 ltr">
              <div className="flex gap-1 justify-center">
                <span className="body-16px-regular text-gray-4">
                  {t("rial")}
                </span>
                <span className="h-20px-demibold text-gray-4">
                  {digitsEnToFa(`${amount?.toLocaleString()}`)}
                </span>
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center relative">
            <span
              className={`body-14px-medium tracking-normal text-gray-0  ${before}`}
            >
              {t("bank.date-and-time")}
            </span>
            <span className="body-14px-medium tracking-normal text-gray-4 ltr">
              {digitsEnToFa(`${configs.converToPersianDateTime(updated_at)}`)}
            </span>
          </div>
          <div className="flex justify-between items-center relative">
            <span
              className={`body-14px-medium tracking-normal text-gray-0  ${before}`}
            >
              {t("bank.payment-method")}
            </span>
            <span className="body-14px-medium tracking-normal text-gray-4">
              {paymentMethodType({ transaction_type, t })}
            </span>
          </div>
          <div className="flex justify-between items-center relative">
            <span
              className={`body-14px-medium tracking-normal text-gray-0  ${before}`}
            >
              {t("bank.tracking-code")}
            </span>
            <span className="body-14px-medium tracking-normal text-gray-4">
              {digitsEnToFa(`${bank_reference}`)}
            </span>
          </div>
        </div>
        <div className=" flex flex-col justify-center items-center pt-5 mt-5 border-t border-gary--8">
          <div className=" flex items-center gap-4">
            <div className=" h-10 w-10 rounded-[4px] bg-[#39B2C0] flex items-center justify-center">
              <LogoFirouzehWigth className="w-6 " />
            </div>
            <div className="text-right">
              <div className="body-12px-medium">{t("bank.firouzeh-app")}</div>
              <div className="caption-12px-regular">
                {t("bank.finance-chain")}
              </div>
            </div>
          </div>
          <div className="body-12px-medium tracking-[3.72px] text-gray-0 my-1">
            app.firouzeh.com
          </div>
          <div className="flex justify-center items-center gap-1">
            <LogoFirouzehWithoutTypo className="w-6" />

            <div className="body-10px-medium text-gray-0">
              {t("bank.firouzeh-group")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankActivation;
